<template>
  <a-modal
    :maskClosable="false"
    width="50%"
    :loading="loading"
    :title="modalTitle"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-row>
        <a-col :span="12">          
          <a-form-item label="驾校名称" v-bind="formItemLayout">
            <a-input
              v-decorator="['drivschname',{rules: [{ required: true, message: '请输入驾校名称!' }] , initialValue: updateSchoolModal ? updateSchoolModal['drivschname'] : ''}]"
              placeholder="请输入驾校名称"
            />
          </a-form-item>
          
          <a-form-item label="省代码" v-bind="formItemLayout">
            <a-input
              v-decorator="['provice',{rules: [{ required: true, message: '请输入省代码' }] , initialValue: updateSchoolModal ? updateSchoolModal['provice'] : ''}]"
              placeholder="请输入省代码"
            />
          </a-form-item>
          
          <a-form-item label="区县代码" v-bind="formItemLayout">
            <a-input
              v-decorator="['county',{rules: [{ required: true, message: '请输入区县代码' }] , initialValue: updateSchoolModal ? updateSchoolModal['county'] : ''}]"
              placeholder="请输入区县代码"
            />
          </a-form-item>
          <a-form-item label="联系人名称" v-bind="formItemLayout">
            <a-input
              v-decorator="['contactsname',{rules:[{validator:checkName}],initialValue: updateSchoolModal ? updateSchoolModal['contactsname'] : ''}]"
              placeholder="请输入联系人名称"
            />
          </a-form-item>
          <a-form-item label="联系人邮箱" v-bind="formItemLayout">
            <a-input
              v-decorator="['contactsemail',{rules:[{type:'email',message:'请输入有效邮箱！'}],initialValue: updateSchoolModal ? updateSchoolModal['contactsemail'] : ''}]"
              placeholder="请输入联系人邮箱"
            />
          </a-form-item>
          <a-form-item label="财务联系人" v-bind="formItemLayout">
            <a-input
              v-decorator="['fincontactsname',{rules:[{validator:checkName}],initialValue: updateSchoolModal ? updateSchoolModal['fincontactsname'] : ''}]"
              placeholder="请输入财务联系人"
            />
          </a-form-item>
          <a-form-item label="财务邮箱" v-bind="formItemLayout">
            <a-input
              v-decorator="['fincontactsemail',{rules:[{type:'email',message:'请输入有效邮箱！'}],initialValue: updateSchoolModal ? updateSchoolModal['fincontactsemail'] : ''}]"
              placeholder="请输入财务邮箱"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="驾校ID" v-bind="formItemLayout">
            <a-input
              :disabled="updateSchoolModal"
              v-decorator="['drivschid',{rules:[{required:true,whitespace:true,message:'请输入有效的驾校ID'}],initialValue: updateSchoolModal ? updateSchoolModal['drivschid'] : ''}]"
              placeholder="请输入驾校ID"
            />
          </a-form-item>
          <a-form-item label="驾校简称" v-bind="formItemLayout">
            <a-input
              v-decorator="['drivschshtname',{rules:[{required:true,whitespace:true,message:'请输入有效的驾校简称！'}],initialValue: updateSchoolModal ? updateSchoolModal['drivschshtname'] : ''}]"
              placeholder="请输入驾校简称"
            />
          </a-form-item>
          <a-form-item label="城市代码" v-bind="formItemLayout">
            <a-input
              v-decorator="['city',{rules: [{ required: true, message: '请输入城市代码' }] , initialValue: updateSchoolModal ? updateSchoolModal['city'] : ''}]"
              placeholder="请输入城市代码"
            />
          </a-form-item>
          <a-form-item label="驾校地址" v-bind="formItemLayout">
            <a-textarea
              v-decorator="['drivschadress',{initialValue: updateSchoolModal ? updateSchoolModal['drivschadress'] : ''}]"
              placeholder="请输入驾校地址"
              :autosize="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
          
          <a-form-item label="联系人手机" v-bind="formItemLayout">
            <a-input
              v-decorator="['contactsmobile',{rules:[{validator:checkMobile}],initialValue: updateSchoolModal ? updateSchoolModal['contactsmobile'] : ''}]"
              placeholder="请输入联系人手机"
            />
          </a-form-item>
          <a-form-item label="联系人电话" v-bind="formItemLayout">
            <a-input
              v-decorator="['contactsphone',{rules:[{validator:checkTelephone}],initialValue: updateSchoolModal ? updateSchoolModal['contactsphone'] : ''}]"
              placeholder="请输入联系人电话"
            />
          </a-form-item>
          
          <a-form-item label="财务手机" v-bind="formItemLayout">
            <a-input
              v-decorator="['finacontactsmobile',{rules:[{validator:checkMobile}],initialValue: updateSchoolModal ? updateSchoolModal['finacontactsmobile'] : ''}]"
              placeholder="请输入财务手机"
            />
          </a-form-item>
          
          <a-form-item label="财务电话" v-bind="formItemLayout">
            <a-input
              v-decorator="['fincontactsphone',{rules:[{validator:checkTelephone}],initialValue: updateSchoolModal ? updateSchoolModal['fincontactsphone'] : ''}]"
              placeholder="请输入财务电话"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import FormValid from "../libs/common/FormValid"
export default {
  name: "SchoolCUModal",
  props: ["updateSchoolModal", "title"],
  data() {
    return {
      user_id: this.$cache.session.get(this.$marco.constants.KEY_USER_ID),
      org_id:this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
      visible: false,
      loading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 }
      }
    };
  },
  created() {
    this.visible = true;
    this.form.resetFields();
  },
  computed: {
    modalTitle() {
      return this.title
        ? this.title
        : this.updateSchoolModal
        ? "修改驾校"
        : "新增驾校";
    }
  },
  methods: {
    handleOk() {
      const that = this;
      this.form.validateFields((err, values) => {
        if (err) return;
        values['drivasstid'] = that.org_id;
        let url;
        url = that.$marco.api.schoolAdd;
        if (this.updateSchoolModal) {
          url = that.$marco.api.schoolUpdate;
          values["modopr"] = that.user_id;
        } else {
        }

        that.submitForm(url, values);
      });
    },
    handleCancel() {
      this.visible = false;
      this.$emit("close");
    },
    submitForm(url, values) {
      const that = this;
      that.loading = true;
      that.$http.post(
        url,
        values,
        data => {
          that.loading = false;
          that.$message.success(
            that.updateSchoolModal ? "修改成功" : "添加成功"
          );
          that.$emit("close", true);
        },
        errorDesc => {
          that.loading = false;
          that.$log.normal(JSON.stringify(errorDesc));
          that.$message.error(errorDesc);
        },
        error => {
          that.loading = false;
          that.$log.error(JSON.stringify(error));
          that.$message.error(error);
        },
        that
      );
    },
    checkMobile(rule, value, callback) {
      value.length != 0 && !FormValid.checkMobilePhone(value)
        ? callback(new Error("请输入有效手机号！"))
        : callback();
    },
    checkName(rule, value, callback) {
      value.length != 0 && !FormValid.checkName(value)
        ? callback(new Error("请输入合法名称！"))
        : callback();
    },
    checkTelephone(rule, value, callback) {
      value.length != 0 && !FormValid.telephone(value)
        ? callback(new Error("请输入有效的固定电话！"))
        : callback();
    }
  }
};
</script>
<style>
</style>
